import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[onlyPositiveDigits]',
    standalone: false
})
export class OnlyPositiveDigitsDirective {
  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const initialValue = this.el.nativeElement.value;
    let newValue = initialValue.replace(/[^0-9.]*/g, '');
    
    // Handle multiple decimals
    newValue = newValue.replace(/\.{2,}/g, '.');

    // Add leading zero if starts with decimal
    if (newValue.startsWith('.')) {
      newValue = '0' + newValue;
    }

    // Ensure only one decimal point
    const parts = newValue.split('.');
    if (parts.length > 2) {
      newValue = parts[0] + '.' + parts.slice(1).join('');
    }

    if (initialValue !== newValue) {
      this.el.nativeElement.value = newValue;
      event.stopPropagation();
    }
  }

  @HostListener('keypress', ['$event']) onKeyPress(_event: Event) {
    const event = _event as KeyboardEvent;
    const charCode = event.which ? event.which : event.keyCode;
    const inputChar = String.fromCharCode(charCode);
    const currentValue = this.el.nativeElement.value;

    // Allow digits and dot
    if (inputChar === '.' && currentValue.indexOf('.') === -1) {
      return; // Allow only one dot
    }
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault(); // Prevent non-digit characters
    }
  }
}